<template>
  <section v-if="callAction != ''" class="calltoaction-area">
    <div class="calltoaction-wrapper">
      <img :src="$imgURL + callAction[0].insInstitucionalImagens[0].itgUrlImagem" class="cta-bg-img" alt="">

      <div class="container">
        <div class="row ">
          <div class="col-lg-8 col-md-12">
            <div class="calltoaction-caption">
              <h2>{{ callAction[0].itiNome }}</h2>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 text-lg-right calltoaction-btn">
            <router-link :to="callAction[0].itiLinkBtn1" class="btn_cta_white">{{ callAction[0].itiTextoBtn1 }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageCallAction',

  data: () => ({
    callAction: [],
  }),

  methods: {

  },

  created() {

    //aqui busca callaction
    axios.get('/Process/InsInstitucional/institucional/58/callaction/0/x')
      .then(response => {
        this.callAction = response.data;
        //console.log('callaction')
        //console.log(this.callAction)
      })
      .catch(error => {
        console.error(error);
      });

  }
};
</script>